import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enTranslation from "./en/en";

const resources = {
  en: {
    translation: enTranslation
  }
};

export default i18n.use(initReactI18next).init({
  resources,
  lng: "en",

  interpolation: {
    // react already safes from XSS:
    escapeValue: false
  }
});
